<!-- Crossword.vue -->
<template>
	<div class="puzzle-container">
		<div class="grid-container">
			<section class="newcr-header mb-3">
				<h5 id="hideinmobile">Crossword</h5>
				<div class="d-flex gap-3 newcr-100">
					<article>
						<h5>Timer</h5>
						<h4>{{ formattedTime }}</h4>
					</article>
					<!-- <article>
						<h5>Score</h5>
						<h4>{{ score }}</h4>
					</article> -->
				</div>
			</section>
			<div class="mobile-crossword-scroll">
				<div id="crosswordGrid">
					<div class="newcr-boundary">
						<div
							v-for="(row, rowIndex) in gridSize.maxRow"
							:key="'row-' + rowIndex"
							class="grid-row"
							style="display: flex"
						>
							<div
								v-for="(col, colIndex) in gridSize.maxCol"
								:key="'cell-' + rowIndex + '-' + colIndex"
								:class="['cell', getCellClass(rowIndex, colIndex)]"
								:data-row="rowIndex"
								:data-col="colIndex"
							>
								<template v-if="!isCellBlack(rowIndex, colIndex)">
									<input
										:ref="`input-${rowIndex}-${colIndex}`"
										v-model="gridValues[`${rowIndex},${colIndex}`]"
										maxlength="1"
										:data-row="rowIndex"
										:data-col="colIndex"
										@focus="handleCellFocus($event, rowIndex, colIndex)"
										@input="handleInput($event, rowIndex, colIndex)"
										@keydown="handleKeydown($event, rowIndex, colIndex)"
										@click="$event.target.select()"
										:disabled="answerReveled"
									/>
									<div
										v-if="getCellNumberAcross(rowIndex, colIndex)"
										:class="[
											'cell-number-across',
											{
												'cell-number-across-overlap': hasBothNumbers(
													rowIndex,
													colIndex
												),
											},
										]"
									>
										{{ getCellNumberAcross(rowIndex, colIndex) }}
									</div>
									<div
										v-if="getCellNumberDown(rowIndex, colIndex)"
										:class="[
											'cell-number-down',
											{
												'cell-number-down-overlap': hasBothNumbers(
													rowIndex,
													colIndex
												),
											},
										]"
									>
										{{ getCellNumberDown(rowIndex, colIndex) }}
									</div>
								</template>
							</div>
						</div>
					</div>
				</div>
			</div>
			
			<!-- <button class="check-button" @click="submitPuzzle">Submit</button>
			<button class="check-button" @click="resetPuzzle">Reset Puzzle</button> -->
			<div class="d-flex pr-3 position-relative newcr-mt-3">
				<b-button
					:disabled="submitted || !allCellsFilled"
					@click="answerReveled ? newGame() : submitPuzzle()"
					class="candash-addBtn-js fs-16 width-220"
					>{{ answerReveled ? "New Game" : "Submit" }}</b-button
				>
				<b-dropdown
					id="laptopdropdown"
					no-caret
					class="revealdropdown reveal-drop-parent ml-2 width-220"
				>
					<template #button-content>
						Reveal
						<img
							src="../../assets/newdesign/dashboard/games/bluedown.svg"
							alt=""
						/>
					</template>
					<div class="game-dropdown-overflow">
						<b-dropdown-item @click="showAnswer" :disabled="answerReveled"
							>Reveal Puzzle</b-dropdown-item
						>
						<b-dropdown-item
							@click="revealSelectedClueAnswer"
							:disabled="
								!selectedClue.direction || answerReveled || clueCount >= 3
							"
							>Reveal Word</b-dropdown-item
						>
						<b-dropdown-item
							@click="revealFocusedCellLetter"
							:disabled="
								!selectedCell ||
								answerReveled ||
								letterReveals >= 5 ||
								!selectedClue.direction
							"
							>Reveal Letter</b-dropdown-item
						>
					</div>
				</b-dropdown>

				<div
					@click="answerReveled ? '' : (showReset = true)"
					class="reset-twozero-hover newcr-top-2"
					:class="{ 'opac-5 pointer-none': submitted || answerReveled }"
				>
					<img
						src="../../assets/newdesign/dashboard/games/reset-game.svg"
						alt=""
					/>
					<span class="pr-3 ml-2">Reset game</span>
				</div>
			</div>
		</div>

		<div class="clues-container">
			<div class="clues-section">
				<h3>ACROSS</h3>
				<div id="acrossClues">
					<div
						v-for="(clue, number) in crosswordData.across"
						:key="'across-' + number"
						:class="[
							'clue-item',
							{ selected: isClueSelected('across', number) },
						]"
						@click="handleClueClick('across', number)"
						class="d-flex align-items-start"
						@copy.prevent
						@contextmenu.prevent
					>
						<div
							class="w10 new-cr-number d-flex align-items-center justify-content-between"
						>
							{{ number }} <span class="newcr-vertical-line"></span>
						</div>
						<div class="w-90 pl-2 new-cr-clue">
							{{ clue.clue }}
						</div>
					</div>
				</div>
			</div>
			<div class="clues-section">
				<h3>DOWN</h3>
				<div id="downClues">
					<div
						v-for="(clue, number) in crosswordData.down"
						:key="'down-' + number"
						:class="['clue-item', { selected: isClueSelected('down', number) }]"
						@click="handleClueClick('down', number)"
						class="d-flex align-items-start"
						@copy.prevent
						@contextmenu.prevent
					>
						<div
							class="w10 new-cr-number d-flex align-items-center justify-content-between"
						>
							{{ number }} <span class="newcr-vertical-line"></span>
						</div>
						<div class="w-90 pl-2 new-cr-clue">{{ clue.clue }}</div>
					</div>
				</div>
			</div>
		</div>
		<ResetModal
			v-if="showReset"
			:showReset="showReset"
			@close-modal="showReset = false"
			@resetGame="resetPuzzle"
		/>
	</div>
</template>

<script>
import {
	getGameState,
	saveGameState,
	submitGameScore,
	saveActivity,
	deleteGameState,
} from "@/utils/apiFunctions";
import CryptoJS from "crypto-js";
import ResetModal from "./ResetModal.vue";
export default {
	data() {
		return {
			showReset: false,
			incompleteCell: false,
			GAME_ENCRYPTION_KEY: "M3kyY2RYu9tVUZcU",
			// gridSize: 27,
			selectedCell: null,
			letterReveals: 0,
			submitted: false,
			currentDirection: "across",
			selectedCell: null,
			gridValues: {},
			highlightedCells: new Set(),
			selectedClue: { direction: null, number: null },
			columnSize: 0,
			currentSeries: 0,
			incorrectCells: new Set(),
			crosswordData: {},
			encryptedCrossword: {},
			newWidth: 0,
			secondsElapsed: 0,
			timer: null,
			score: 0,
			answerReveled: false,
			timeCreated: null,
			clueCount: 0,
		};
	},
	components: { ResetModal },
	mounted() {
		this.startActivityTimer();
		window.addEventListener("beforeunload", this.saveStateOnReload);
	},
	computed: {
		allCellsFilled() {
			for (let row = 0; row < this.gridSize.maxRow; row++) {
				for (let col = 0; col < this.gridSize.maxCol; col++) {
					if (!this.isCellBlack(row, col)) {
						const cellValue = this.gridValues[`${row},${col}`];
						if (!cellValue || cellValue.trim() === "") {
							return false;
						}
					}
				}
			}
			return true;
		},
		formattedTime() {
			let hours = Math.floor(this.secondsElapsed / 3600);
			let minutes = Math.floor((this.secondsElapsed % 3600) / 60);
			let seconds = this.secondsElapsed % 60;
			return (
				String(hours).padStart(2, "0") +
				":" +
				String(minutes).padStart(2, "0") +
				":" +
				String(seconds).padStart(2, "0")
			);
		},
		gridSize() {
			let maxRow = 0;
			let maxCol = 0;

			// Helper function to check word boundaries
			const updateMaxDimensions = (wordData, direction) => {
				const row = wordData.row;
				const col = wordData.col;
				const length = wordData.answer.length;

				if (direction === "across") {
					maxRow = Math.max(maxRow, row);
					maxCol = Math.max(maxCol, col + length - 1);
				} else {
					maxRow = Math.max(maxRow, row + length - 1);
					maxCol = Math.max(maxCol, col);
				}
			};

			Object.values(this.crosswordData?.across || {}).forEach((wordData) => {
				updateMaxDimensions(wordData, "across");
			});

			// Check down words
			Object.values(this.crosswordData?.down || {}).forEach((wordData) => {
				updateMaxDimensions(wordData, "down");
			});

			// Add some padding to the grid (2 cells on each side)
			const padding = 0;
			return {
				maxRow: maxRow + padding,
				maxCol: maxCol + padding,
			};
		},
	},
	async created() {
		await this.loadSavedState();
		this.startTimer();
		if (this.answerReveled) clearInterval(this.timer);
		setTimeout(() => {
			this.updateWidth();
		}, 3000);
	},
	beforeDestroy() {
		clearInterval(this.activityInterval);
		window.removeEventListener("beforeunload", this.saveStateOnReload);
		if (this.timer) {
			this.saveState();
			clearInterval(this.timer);
		}
	},
	methods: {
		handleDropdownShown() {
			if (this.selectedCell) {
				console.log("the cell is", this.selectedCell);
				this.$nextTick(() => {
					// Remove 'selected-cell' class from any existing elements
					const previouslySelected =
						document.querySelectorAll(".selected-cell");
					previouslySelected.forEach((el) =>
						el.classList.remove("selected-cell")
					);

					// Find the new selected cell
					const cellElement = document.querySelector(
						`[data-row="${this.selectedCell.row}"][data-col="${this.selectedCell.col}"]`
					);

					if (cellElement) {
						const inputElement = cellElement.querySelector("input");
						if (inputElement) {
							inputElement.classList.add("selected-cell");
							console.log("Selected cell:", inputElement);
						}
					} else {
						console.error("Cell not found!");
					}
				});
			}
		},
		revealFocusedCellLetter() {
			if (!this.selectedCell) return;

			const { row, col } = this.selectedCell;
			const acrossWord = this.findWord(row, col, "across");
			const downWord = this.findWord(row, col, "down");

			let correctLetter = null;

			if (acrossWord) {
				const { row: startRow, col: startCol, answer } = acrossWord;
				const letterIndex = col - (startCol - 1);
				correctLetter = answer[letterIndex];
			} else if (downWord) {
				const { row: startRow, col: startCol, answer } = downWord;
				const letterIndex = row - (startRow - 1);
				correctLetter = answer[letterIndex];
			}

			if (correctLetter) {
				this.$set(
					this.gridValues,
					`${row},${col}`,
					correctLetter.toUpperCase()
				);
				this.saveState();
				this.letterReveals = (this.letterReveals || 0) + 1;
				this.clearHighlights();
			}
		},
		revealSelectedClueAnswer() {
			if (!this.selectedClue.direction || !this.selectedClue.number) return;
			const { direction, number } = this.selectedClue;
			const wordData = this.crosswordData[direction][number];

			if (!wordData) return;

			const { row, col, answer } = wordData;

			for (let i = 0; i < answer.length; i++) {
				const currentRow = direction === "across" ? row - 1 : row - 1 + i;
				const currentCol = direction === "across" ? col - 1 + i : col - 1;
				this.$set(
					this.gridValues,
					`${currentRow},${currentCol}`,
					answer[i].toUpperCase()
				);
			}
			this.clueCount += 1;
			// this.answerReveled = true;
			this.saveState();
			this.clearHighlights();
		},
		async newGame() {
			const deletes = await deleteGameState("crossword");
			if (deletes.status == 200) {
				this.loadSavedState();
				this.startTimer();
			}
		},
		showAnswer() {
			this.answerReveled = true;
			for (const direction of ["across", "down"]) {
				for (const [number, wordData] of Object.entries(
					this.crosswordData[direction]
				)) {
					const { row, col, answer } = wordData;

					for (let i = 0; i < answer.length; i++) {
						const currentRow = direction === "across" ? row - 1 : row - 1 + i;
						const currentCol = direction === "across" ? col - 1 + i : col - 1;
						this.$set(
							this.gridValues,
							`${currentRow},${currentCol}`,
							answer[i].toUpperCase()
						);
					}
				}
			}
			clearInterval(this.timer);
			this.saveState();
		},
		updateWidth() {
			let column = this.gridSize.maxCol;
			var width = document.getElementById("crosswordGrid").offsetWidth;
			this.newWidth = width / column;
		},
		saveStateOnReload() {
			this.saveState();
		},
		startTimer() {
			clearInterval(this.timer);
			this.timer = setInterval(() => {
				this.secondsElapsed += 1;
			}, 1000);
		},

		isCellBlack(row, col) {
			// Check if the cell is part of any word
			return (
				!this.findWord(row, col, "across") && !this.findWord(row, col, "down")
			);
		},
		getCellClass(row, col) {
			return {
				black: this.isCellBlack(row, col),
				highlighted: this.isHighlighted(row, col),
				incorrect: this.incorrectCells.has(`${row},${col}`),
			};
		},
		isHighlighted(row, col) {
			return this.highlightedCells.has(`${row},${col}`);
		},
		getCellNumberAcross(row, col) {
			for (const [number, data] of Object.entries(this.crosswordData.across)) {
				if (data.row - 1 === row && data.col - 1 === col) {
					return number;
				}
			}
			return null;
		},
		getCellNumberDown(row, col) {
			for (const [number, data] of Object.entries(this.crosswordData.down)) {
				if (data.row - 1 === row && data.col - 1 === col) {
					return number;
				}
			}
			return null;
		},
		hasBothNumbers(row, col) {
			return (
				this.getCellNumberAcross(row, col) && this.getCellNumberDown(row, col)
			);
		},
		handleCellFocus(event, row, col) {
			this.clearHighlights();

			this.selectedCell = { row, col };
			this.handleDropdownShown();
			const acrossWord = this.findWord(row, col, "across");
			const downWord = this.findWord(row, col, "down");

			if (acrossWord && !downWord) {
				this.currentDirection = "across";
			} else if (!acrossWord && downWord) {
				this.currentDirection = "down";
			}

			this.highlightWord(row, col, this.currentDirection);
			event.target.select();
		},
		handleInput(event, row, col) {
			let value = event.target.value.toUpperCase();
			if (!/^[A-Z]$/.test(value) && value !== "") {
				value = "";
			}

			this.$set(this.gridValues, `${row},${col}`, value);
			this.incorrectCells.delete(`${row},${col}`);

			this.saveState();

			if (value) {
				// Check word in both directions when a letter is entered
				const directions = ["across", "down"];
				for (const direction of directions) {
					const wordData = this.findWord(row, col, direction);
					if (wordData) {
						const isComplete = this.isWordComplete(wordData);
						let isCompletes = true;
						let completedCount = 0;

						this.incorrectCells.clear();

						for (const direction of ["across", "down"]) {
							for (const [number, wordData] of Object.entries(
								this.crosswordData[direction]
							)) {
								const { row, col, answer } = wordData;
								let wordComplete = true;
								let userAnswer = "";
								let cellPositions = [];

								// Build the user's answer and track cell positions
								for (let i = 0; i < answer.length; i++) {
									let currentRow =
										direction === "across" ? row - 1 : row - 1 + i;
									let currentCol =
										direction === "across" ? col - 1 + i : col - 1;

									cellPositions.push({ row: currentRow, col: currentCol });
									const cellValue =
										this.gridValues[`${currentRow},${currentCol}`] || "";

									if (!cellValue) {
										wordComplete = false;
										isCompletes = false;
									}

									userAnswer += cellValue;
								}
								if (
									wordComplete &&
									userAnswer.toLowerCase() === answer.toLowerCase()
								) {
									completedCount++;
									this.score = completedCount * 10;
									this.saveState();
								}
							}
						}
					}
				}

				// Move focus to the next cell if input is valid
				const nextCell = this.getNextCell(row, col);
				if (nextCell) {
					this.$refs[`input-${nextCell.row}-${nextCell.col}`][0].focus();
				}
			}
		},

		isWordComplete(wordData) {
			const { row, col, answer, direction } = wordData;
			for (let i = 0; i < answer.length; i++) {
				const currentRow = direction === "across" ? row - 1 : row - 1 + i;
				const currentCol = direction === "across" ? col - 1 + i : col - 1;
				const cellValue = this.gridValues[`${currentRow},${currentCol}`];
				if (!cellValue) {
					return false;
				}
			}
			return true;
		},

		isWordCorrect(wordData) {
			const { row, col, answer, direction } = wordData;
			let constructedWord = "";
			for (let i = 0; i < answer.length; i++) {
				const currentRow = direction === "across" ? row - 1 : row - 1 + i;
				const currentCol = direction === "across" ? col - 1 + i : col - 1;
				const cellValue = this.gridValues[`${currentRow},${currentCol}`] || "";
				constructedWord += cellValue;
			}
			const isCorrect = constructedWord.toUpperCase() === answer.toUpperCase();
			return isCorrect;
		},
		resetPuzzle() {
			if (this.answerReveled) return;
			this.gridValues = {};
			this.score = 0;
			this.saveState();
			this.$nextTick(() => {
				
				const firstEmptyCell = this.$refs["input-0-0"];
				if (firstEmptyCell) {
					firstEmptyCell.focus();
				}
			});
			setTimeout(() => {
				this.showReset = false;
			}, 1000);
		},
		handleKeydown(event, row, col) {
			if (event.key === "Backspace" && !this.gridValues[`${row},${col}`]) {
				event.preventDefault();
				const prevCell = this.getPreviousCell(row, col);
				if (prevCell) {
					this.$refs[`input-${prevCell.row}-${prevCell.col}`][0].focus();
					this.$set(this.gridValues, `${prevCell.row},${prevCell.col}`, "");
				}
			} else if (
				["ArrowRight", "ArrowLeft", "ArrowUp", "ArrowDown"].includes(event.key)
			) {
				event.preventDefault();
				this.currentDirection = ["ArrowRight", "ArrowLeft"].includes(event.key)
					? "across"
					: "down";
				const nextCell = this.getAdjacentCell(row, col, event.key);
				if (nextCell) {
					this.$refs[`input-${nextCell.row}-${nextCell.col}`][0].focus();
				}
			}
		},
		handleClueClick(direction, number) {
			const wordData = this.crosswordData[direction][number];
			const row = wordData.row - 1;
			const col = wordData.col - 1;

			this.currentDirection = direction;
			this.clearHighlights();
			this.highlightWord(row, col, direction);

			this.selectedClue = { direction, number };

			// Focus first cell of word
			this.$refs[`input-${row}-${col}`][0].focus();
		},
		clearHighlights() {
			console.log("it is here to clear");
			this.highlightedCells.clear();
			this.selectedClue = { direction: null, number: null };
		},
		highlightWord(row, col, direction) {
			const wordData = this.findWord(row, col, direction);

			if (wordData) {
				const { row: startRow, col: startCol, answer } = wordData;

				for (let i = 0; i < answer.length; i++) {
					const currentRow =
						direction === "across" ? startRow - 1 : startRow - 1 + i;
					const currentCol =
						direction === "across" ? startCol - 1 + i : startCol - 1;
					this.highlightedCells.add(`${currentRow},${currentCol}`);
				}

				// Find and highlight corresponding clue
				for (const [number, data] of Object.entries(
					this.crosswordData[direction]
				)) {
					if (data === wordData) {
						this.selectedClue = { direction, number };
						break;
					}
				}
			}
		},
		findWord(row, col, direction) {
			const words = this.crosswordData[direction];
			for (const wordData of Object.values(words)) {
				const startRow = wordData.row - 1;
				const startCol = wordData.col - 1;
				const length = wordData.answer.length;

				if (direction === "across") {
					if (row === startRow && col >= startCol && col < startCol + length) {
						return wordData;
					}
				} else {
					if (col === startCol && row >= startRow && row < startRow + length) {
						return wordData;
					}
				}
			}
			return null;
		},
		getNextCell(row, col) {
			if (this.currentDirection === "across") {
				const nextCol = col + 1;
				if (this.findWord(row, nextCol, "across")) {
					return { row, col: nextCol };
				}
			} else {
				const nextRow = row + 1;
				if (this.findWord(nextRow, col, "down")) {
					return { row: nextRow, col };
				}
			}
			return null;
		},

		getPreviousCell(row, col) {
			if (this.currentDirection === "across") {
				const prevCol = col - 1;
				if (this.findWord(row, prevCol, "across")) {
					return { row, col: prevCol };
				}
			} else {
				const prevRow = row - 1;
				if (this.findWord(prevRow, col, "down")) {
					return { row: prevRow, col };
				}
			}
			return null;
		},
		getAdjacentCell(row, col, direction) {
			let nextRow = row;
			let nextCol = col;

			switch (direction) {
				case "ArrowRight":
					nextCol += 1;
					break;
				case "ArrowLeft":
					nextCol -= 1;
					break;
				case "ArrowUp":
					nextRow -= 1;
					break;
				case "ArrowDown":
					nextRow += 1;
					break;
			}

			if (this.findWord(nextRow, nextCol, this.currentDirection)) {
				return { row: nextRow, col: nextCol };
			}
			return null;
		},
		isClueSelected(direction, number) {
			return (
				this.selectedClue.direction === direction &&
				this.selectedClue.number === number
			);
		},
		async submitPuzzle() {
			let isComplete = true;
			let allCorrect = true;
			let incompleteWords = [];
			let incorrectWords = [];
			let completedCount = 0;

			// Clear previous incorrect cells
			this.incorrectCells.clear();

			// Check each word in both directions
			for (const direction of ["across", "down"]) {
				for (const [number, wordData] of Object.entries(
					this.crosswordData[direction]
				)) {
					const { row, col, answer } = wordData;
					let wordComplete = true;
					let userAnswer = "";
					let cellPositions = [];

					// Build the user's answer and track cell positions
					for (let i = 0; i < answer.length; i++) {
						let currentRow = direction === "across" ? row - 1 : row - 1 + i;
						let currentCol = direction === "across" ? col - 1 + i : col - 1;

						cellPositions.push({ row: currentRow, col: currentCol });
						const cellValue =
							this.gridValues[`${currentRow},${currentCol}`] || "";

						if (!cellValue) {
							wordComplete = false;
							isComplete = false;
						}

						userAnswer += cellValue;
					}

					// Add incomplete word to list
					if (wordComplete) {
						completedCount++;
					} else {
						incompleteWords.push(`${number} ${direction}`);
						continue;
					}

					// Clean and compare answers
					const cleanUserAnswer = userAnswer.trim().toUpperCase();
					const cleanCorrectAnswer = answer.trim().toUpperCase();

					if (cleanUserAnswer !== cleanCorrectAnswer) {
						allCorrect = false;
						incorrectWords.push(`${number} ${direction}`);

						// Mark all cells in this word as incorrect
						cellPositions.forEach((pos) => {
							this.incorrectCells.add(`${pos.row},${pos.col}`);
						});
					}
				}
			}

			if (!isComplete) {
				return;
			}

			if (allCorrect) {
				let score = 0;
				if (this.secondsElapsed <= 5 * 60) {
					score = 420;
				} else if (this.secondsElapsed <= 10 * 60) {
					score = 280;
				} else {
					score = 140;
				}
				this.score = score;
				this.submitted = true;
				let payload = {
					score: this.score,
				};
				const response = await submitGameScore("crossword", payload);
				if (response.status == 200 || response.status == 201) {
					this.$emit("gameOver", true, this.score);
				}
			}
			this.$nextTick(() => {
				this.$forceUpdate(); // This forces the re-render of the grid
			});
		},

		startActivityTimer() {
			this.activityInterval = setInterval(async () => {
				await saveActivity("crossword");
			}, 30000);
		},
		clearIncorrectHighlights() {
			this.incorrectCells.clear();
		},

		async saveState() {
			const payload = {
				game: "crossword",
				state: {
					crossword: this.encryptedCrossword,
					gridValues: this.gridValues,
					currentDirection: this.currentDirection,
					currentTime: this.secondsElapsed,
					partial_score: this.score,
					reveal: this.answerReveled,
					clueCount: this.clueCount,
					letterReveals: this.letterReveals, // Add this line
				},
			};
			const response = await saveGameState(payload);
		},
		decryptAnswer(encryptedText) {
			try {
				const encryptedData = CryptoJS.enc.Base64.parse(encryptedText);

				// Extract IV (first 16 bytes) and ciphertext
				const iv = CryptoJS.lib.WordArray.create(
					encryptedData.words.slice(0, 4)
				);
				const ciphertext = CryptoJS.lib.WordArray.create(
					encryptedData.words.slice(4)
				);

				// Decrypt using AES-CBC
				const decrypted = CryptoJS.AES.decrypt(
					{ ciphertext },
					CryptoJS.enc.Utf8.parse(this.GAME_ENCRYPTION_KEY),
					{ iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
				);

				return decrypted.toString(CryptoJS.enc.Utf8);
			} catch (error) {
				console.error("Decryption failed:", error);
				return null;
			}
		},
		async processCrossword(response) {
			const encryptedCrossword =
				response.data?.data?.state?.game_data?.crossword ||
				response.data?.data?.state?.crossword;

			if (!encryptedCrossword) {
				return {};
			}

			let decryptedCrossword = { across: {}, down: {} };

			for (const direction of ["across", "down"]) {
				if (encryptedCrossword[direction]) {
					decryptedCrossword[direction] = {};

					for (const clue_id in encryptedCrossword[direction]) {
						const clueData = encryptedCrossword[direction][clue_id];

						if (clueData && typeof clueData === "object" && clueData.answer) {
							decryptedCrossword[direction][clue_id] = {
								...clueData,
								answer: this.decryptAnswer(clueData.answer),
							};
						} else {
							decryptedCrossword[direction][clue_id] = clueData;
						}
					}
				}
			}

			return decryptedCrossword;
		},
		async loadSavedState() {
			const response = await getGameState("crossword");

			if (response.status == 200) {
				this.encryptedCrossword =
					response.data?.data?.state?.game_data?.crossword ||
					response.data?.data?.state?.crossword;
				// this.crosswordData =
				// 	response.data?.data?.state?.game_data?.crossword ||
				// 	response.data?.data?.state?.crossword;
				this.crosswordData = await this.processCrossword(response);
				this.gridValues = response.data?.data?.state?.gridValues || {};
				this.currentSeries = response.data?.data?.serial || 0;
				this.currentDirection =
					response.data?.data?.state?.currentDirection || "down";
				this.secondsElapsed = response.data?.data?.state?.currentTime || 0;
				this.score = response.data?.data?.state?.partial_score || 0;
				this.answerReveled = response.data?.data?.state?.reveal || false;
				this.timeCreated = response.data.data.created;
				this.clueCount = response.data?.data?.state?.clueCount || 0;
				this.letterReveals = response.data?.data?.state?.letterReveals || 0;
				this.$emit("gameLoaded");
			} else {
				console.log("error");
			}
			localStorage.removeItem("crosswordState");
			const savedState = localStorage.getItem("crosswordState");
			if (savedState) {
				const { gridValues, currentDirection } = JSON.parse(savedState);
				this.gridValues = gridValues;
				this.currentDirection = currentDirection;
			}
		},
	},
};
</script>

<style scoped>
.dropdown-button {
	border-radius: 40px !important;
	font-family: "Montserrat", sans-serif;
	padding: 6px 22px !important;
	color: var(--bg-blue) !important;
	font-size: var(--size-13) !important;
	font-weight: 600 !important;
	width: fit-content;
	border: 1px solid var(--bg-proTheme) !important;
}

.puzzle-container {
	display: flex;
	gap: 2rem;
	padding: 2rem;
	width: 100%;
}

.selected-cell {
	border: 1px solid #000 !important;
	border-radius: 2px !important;
}
.grid-container {
	width: 70%;
}
/* .incorrect {
	background-color: #e2677a !important;
} */

.incorrect input {
	background: #f5a6a6;
}
.cell {
	transition: background-color 0.3s ease;
}

.crossword-grid {
	display: grid;
	grid-template-columns: repeat(9, 1fr);
	grid-template-rows: repeat(9, 1fr);
	gap: 1px;
	border: 1px solid #ccc;
	max-height: 100px;
}
.grid-row {
	display: flex;
	justify-content: center;
}

.cell {
	width: 32px;
	height: 35px;
	border: none;
	position: relative;
}

.cell.black {
	background-color: #bac3cf;
}

.cell.highlighted {
	background-color: #e6f3ff;
}

.cell input {
	width: 100%;
	height: 100%;
	border: 1px solid #8a9bae;
	text-align: center;
	font-family: "Lato", sans-serif;
	font-size: 15px;
	padding-top: 5px;
	font-weight: 900;
	color: #2c3e50;
	text-transform: uppercase;
}

.cell-number-across,
.cell-number-down {
	position: absolute;
	font-family: "Lato", sans-serif;
	font-size: 8px;
	font-weight: 700;
	color: #40404c;
}

.cell-number-across {
	top: 1px;
	left: 2px;
}

.cell-number-down {
	top: 0px;
	/* right: 2px; */
	left: 1px;
}

.cell-number-across-overlap {
	position: absolute;
	right: 1px !important;
	left: 1px;
	line-height: 1;
	z-index: 1;
	background: transparent;
	/* color: #000; */
}
.cell-number-down-overlap {
	position: absolute;
	top: 18px !important;
	left: 1px;
	line-height: 1;
	z-index: 1;
	background: transparent;
	/* color: #000; */
}

.cell-number-across-overlap,
.cell-number-down-overlap {
	font-family: "Lato", sans-serif;
	font-size: 8px;
	font-weight: 700;
	color: #40404c;
}

.clues-container {
	display: flex;
	flex-direction: column;
	gap: 1rem;
	width: 30%;
}

.clue-item {
	padding: 0.5rem;
	cursor: pointer;
}

.clue-item:hover {
	background-color: #f5f5f5;
}

.clue-item.selected {
	background-color: #e6f3ff;
}

.check-button {
	margin-top: 1rem;
	padding: 0.5rem 1rem;
	background-color: #4caf50;
	color: white;
	border: none;
	border-radius: 4px;
	cursor: pointer;
}

.check-button:hover {
	background-color: #45a049;
}

.newcr-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.newcr-header h5 {
	font-family: "Lato", sans-serif;
	font-size: 32px;
	font-weight: 900;
	color: #20639b;
	margin-bottom: 0;
	display: flex;
	align-items: center;
}

.newcr-header article {
	background-color: #d9e4f5;
	border-radius: 8px;
	width: 120px;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 10px;
	gap: 7px;
}

.newcr-header article h5 {
	font-family: "Lato", sans-serif;
	font-size: 16px;
	font-weight: 700;
	color: #595959;
}
.newcr-header article h4 {
	font-family: "Lato", sans-serif;
	font-size: 20px;
	font-weight: 900;
	color: #2a4d79;
	margin-bottom: 0;
}

.clues-section {
	background-color: #d9e4f5;
	border-radius: 8px;
	padding: 16px;
	max-height: calc(100vh - 504px);
	min-height: 40%;
}

.clues-section h3 {
	font-family: "Montserrat", sans-serif;
	font-size: 18px;
	font-weight: 700;
	letter-spacing: 0.16em;
	color: #20639b;
}

#crosswordGrid {
	display: flex;
	justify-content: center;
}

.newcr-boundary {
	border: 1px solid #8c8c8c4d;
	background-color: #bac3cf;
	width: 100%;
	padding: 15px;
	border-radius: 8px;
}

.newcr-vertical-line {
	width: 2px;
	height: 22px;
	background-color: #8a9bae;
}

.new-cr-number {
	font-family: "Montserrat", sans-serif;
	font-size: 16px;
	font-weight: 700;
	color: #2c3e50;
}

.new-cr-clue {
	font-family: "Montserrat", sans-serif;
	font-size: 16px;
	font-weight: 500;
	color: #333333;
}

#acrossClues,
#downClues {
	/* min-height: 235px;
	max-height: calc(100vh - 800px); */
	height: 90%;
	overflow: auto;
}

.width-220 {
	width: 220px;
}
.newcr-top-2 {
	top: -2px;
	right: -50px;
}
.newcr-mt-3 {
	margin-top: 15px;
	width: 60%;
	justify-content: flex-end;
}
@media (max-width: 1028px) {
	#crosswordGrid {
		justify-content: unset;

		min-width: 100%;
		flex-shrink: 0;
	}
	.puzzle-container {
		flex-direction: column;
		padding: 10px;
	}
	.grid-container {
		width: 100%;
	}
	.clues-container {
		width: 100%;
	}
	.cell {
		width: 18px;
		height: 23px;
	}
	.mobile-crossword-scroll {
		width: 100%;
		overflow-x: auto;
		display: flex;
	}
	.newcr-100 {
		width: 100%;
	}
	.newcr-header article {
		/* width: 166px; */
		flex: 1;
	}
	#acrossClues,
	#downClues {
		height: unset;
		overflow: unset;
	}
	.newcr-top-2 {
		top: -60px;
		right: unset;
	}
	.newcr-mt-3 {
		margin-top: 80px;
		width: 100% !important;
		justify-content: center;
	}
	.clues-section {
		background-color: unset;
		border-radius: unset;
		padding: unset;
		min-height: unset;
		max-height: unset;
	}
	.newcr-vertical-line {
		display: none;
	}
	.cell input {
		font-size: 11px;
		padding-top: 6px;
	}
	.newcr-boundary {
		padding: 5px;
	}
	.cell-number-across-overlap,
	.cell-number-down-overlap,
	.cell-number-across,
	.cell-number-down {
		font-size: 6px;
	}
	.cell-number-down-overlap {
		top: 1px !important;
	}
	.cell-number-across-overlap {
		left: 10px !important;
		top: 1px;

		/* color: #000; */
	}
}

@media (min-width: 500px) and (max-width: 1028px) {
	.cell {
		width: 25px;
		height: 27px;
	}
	.cell-number-across-overlap,
	.cell-number-down-overlap,
	.cell-number-across,
	.cell-number-down {
		font-size: 10px;
	}
}
@media (min-width: 1029px) and (max-width: 1300px) {
	.cell {
		width: 29px;
		height: 32px;
	}
}
</style>

<style>
.revealdropdown .btn-secondary {
	color: #20639b !important;
	background-color: var(--bg-white) !important;
	background: #ffffff;
	border: 1px solid #20639b !important;
	border-radius: 18px !important;
	height: 100%;
}

.reveal-drop-parent .dropdown-menu {
	border: 2px solid transparent;
	background-color: #f9f9f9;
	border-radius: 14px;
	width: 100%;
}
.revealdropdown .btn-secondary:not(:disabled):not(.disabled):active,
.revealdropdown .btn-secondary:not(:disabled):not(.disabled).active,
.revealdropdown .show > .btn-secondary.dropdown-toggle {
	background-color: var(--bg-white) !important;
	background: #ffffff !important;
	border: 1px solid #20639b !important;
	border-radius: 100px;
	height: 100% !important;
	padding: 7px 15px !important;
}
</style>
